<template>
  <PageContainer
    title="Material Requisition"
    backRoute="/requisitions"
    :editRoute="`/requisitions/${id}/edit`"
    :historyRoute="`/requisitions/${id}/history`"
    :mode="mode"
    collection="requisitions"
    :docID="id"
    @confirmDelete="onConfirmDelete"
    :createdBy="requisition ? requisition.createdBy : null"
    :createdByDate="requisition ? requisition.createdByDate : null"
    :updatedBy="requisition ? requisition.updatedBy : null"
    :updatedByDate="requisition ? requisition.updatedByDate : null"
    :fullscreen="fullscreen"
    :denseNotes="true"
    >
    <v-container
      slot="body"
      fluid
      grid-list-md
      :class="[
        'pt-0 pb-0',
        $vuetify.breakpoint.xsOnly && 'px-0'
      ]"
      :style="{ boxSizing: 'border-box' }"
      >
      <v-layout row wrap v-if="requisition">
        <!-- TO # -->
        <v-flex xs12 v-if="requisition.number">
          <span class="headline">T.O. #{{ requisition.number }}</span>
        </v-flex>

        <!-- Created By -->
        <v-flex xs6 v-if="requisition.createdBy">
          <div class="caption grey--text">Created By</div>
          <div>{{ requisition.createdBy.displayName }}</div>
        </v-flex>

        <!-- Date Created -->
        <v-flex xs6>
          <div class="caption grey--text">Date Created</div>
          <div>{{ requisition.createdByDate | displayDate }}</div>
        </v-flex>

        <!-- Job -->
        <v-flex xs12 md6 v-if="requisition.job">
          <div class="caption grey--text">Job</div>
          <div>{{ `${requisition.job.number} - ${requisition.job.name}` }}</div>
        </v-flex>

        <!-- Shop Drawing -->
        <v-flex xs12 md6 v-if="requisition.shopDrawing">
          <div class="caption grey--text">Shop Drawing</div>
          <div>{{ `${requisition.shopDrawing.number} - ${requisition.shopDrawing.subject}` }}</div>
        </v-flex>

        <!-- Requisiton Items -->
        <v-flex
          xs12
          :class="[
            'sub-form',
            !hasRequisitionItems && 'sub-form--disabled',
            'sub-form--dense',
            'pb-0'
          ]"
          >
          <v-expansion-panel
            v-model="requisitionItemsExpand"
            :disabled="!hasRequisitionItems"
            >
            <v-expansion-panel-content>
              <div slot="header" class="v-expansion-panel-content-header">
                <template v-if="!requisitionItemsInit">
                  <v-progress-circular
                      :size="24"
                      :width="2"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  <span class="subheading ml-3 white--text">Requisiton Items</span>
                </template>
                <template v-else-if="hasRequisitionItems">
                  <v-icon color="white">mdi-garage</v-icon>
                  <span class="subheading ml-3 white--text">Requisiton Items</span>
                  <span  class="ml-1 grey--text text--lighten-1">{{ `(${requisitionItemsLength})` }}</span>
                </template>
                <template v-else>
                  <v-icon disabled>mdi-garage-open</v-icon>
                  <span class="subheading ml-3 white--text">No Requisiton Items</span>
                </template>
              </div>
              <v-card>
                <v-container fluid grid class="pa-0">
                  <v-data-iterator
                    :items="requisitionItems"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    content-tag="v-layout"
                    row
                    wrap
                    >
                    <template
                      slot="item"
                      slot-scope="props"
                      >
                      <router-link
                        :key="props.item.id"
                        class="requisition__item flex px-2 xs12"
                        :to="props.item.route"
                        v-ripple
                        >
                      </router-link>
                      <v-flex
                        :key="props.item.id + 'divider'"
                        xs12
                        class="py-0 px-0"
                       >
                        <v-divider></v-divider>
                      </v-flex>
                    </template>
                  </v-data-iterator>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
     </v-layout>
    </v-container>
  </PageContainer>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex' // eslint-disable-line

import PageContainer from '@/components/Page/PageContainer'
import PageSubField from '@/components/Page/PageSubField'

export default {
  name: 'RequisitionPage',
  components: {
    PageContainer,
    PageSubField
  },
  props: {
    mode: {
      type: String,
      default: 'route'
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      requisitionItemsExpand: null,
      requisitionItemsInit: false,
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      }
    }
  },
  computed: {
    requisitionItems () {
      return []
      /*
      return this.$store.getters['standardItems/items/all'].reduce((acc, standardItem) => {
        if (!has(standardItem, `vendors.${this.id}`)) return acc

        const itemTypes = standardItem.types
        let leafType
        for (let typeID in itemTypes) {
          const type = itemTypes[typeID]
          if (type.level > get(leafType, 'level', 0)) leafType = type
        }
        console.log('routeType: ', leafType)

        const route = `/standard-items/${leafType.id}/item/${standardItem.id}`

        const leafTypeWithConfig = this.itemTypeWithConfig(leafType.id)
        const fields = get(leafTypeWithConfig, 'form')

        acc.push({
          ...standardItem,
          route,
          leafType: leafTypeWithConfig,
          fields
        })

        return acc
      }, [])
      */
    },
    hasRequisitionItems () {
      return this.requisitionItems && this.requisitionItems.length
    },
    requisitionItemsLength () {
      return this.hasRequisitionItems && this.hasRequisitionItems.length
    },

    ...mapGetters({
      user: 'user/saveUser',
      id: 'requisitions/currentID',
      requisition: 'requisitions/currentDocument'
      // requisitionItemsInit: 'requisitionItems/init'
    })
  },
  methods: {
    menuClick (action) {
      console.log('menuClick, option: ', action)
      this[action]()
    },
    print () {
      console.log('menuClick, print')
    },
    email () {
      console.log('menuClick, email')
    },
    copy () {
      console.log('menuClick, copy')
    },

    onConfirmDelete () {
      this.deleteRequisition(this.id)
      this.$router.back()
    },
    ...mapActions('vendors', {
      get: 'get',
      deleteRequisition: 'deleteRequisition'
    })
  },
  created () {
    console.log('REQUISITION PAGE: ', this)
    this.get()
    // this.$store.dispatch('requisitionItems/get')
  }
}
</script>

<style lang="stylus">
.requisition__item
  text-decoration: none
  color: white

  &&:hover
    cursor: pointer
    background-color: rgba(0, 0, 0, 0.06)
</style>
